import React from "react";
import { Stack, Unstable_Grid2 as Grid } from "@mui/material";
import TitleContribute from "@/components/pages/Community/TitleContribute";
import PropTypes from "prop-types";
import styles from "./ContributePanelOptionRender.module.scss";

const ContributePanelOptionRender = ({ items }) => (
  <Stack sx={{ padding: 1 }} direction="column" useFlexGap>
    {items.map((navButtonPanelItem) => {
      const key = `ContributePanelOptionRender-navButtonPanelItem-${navButtonPanelItem.title}`;
      return (
        <React.Fragment key={key}>
          <TitleContribute
            title={navButtonPanelItem.title}
            tooltip={navButtonPanelItem.tooltip}
          />
          <Grid container columnSpacing={4} rowSpacing={2.5}>
            {navButtonPanelItem.options?.map((option) => (
              <Grid md={4} xs={12} key={`${key}-option-${option.name}`}>
                <a href={option.url} className={styles.contributePanelOption}>
                  <div>{option.name}</div>
                  {option.text && (
                    <div className={styles.contributePanelOptionText}>
                      {option.text}
                    </div>
                  )}
                </a>
              </Grid>
            ))}
          </Grid>
        </React.Fragment>
      );
    })}
  </Stack>
);

ContributePanelOptionRender.propTypes = {
  items: PropTypes.array.isRequired
};

export default ContributePanelOptionRender;
